<template>
  <div>
    <div class="app-card-header primary-actions">
      <div class="heading-block">
        <h4 class="heading">{{ data.title }}</h4>
      </div>
    </div>
    <div class="card-body pa-0">
      <v-progress-circular
        v-if="data.status.loading && !Object.keys(data.table.items).length"
        :indeterminate="true"
        :size="75"
        height="3"
        color="primary"
        class="progress-circular" />
      <v-progress-linear
        v-if="data.status.loading && Object.keys(data.table.items).length"
        :indeterminate="true"
        height="3"
        color="primary"
        class="progress-card" />
      <i-list v-if="Object.keys(data.table.items).length && !data.status.noData">
        <i-list-item>
          <span>
            <v-icon color="error" class="mr-3">icon-chart-2</v-icon>
            Seller with lowest price
             ({{data.table.items.minimum.seller}})
          </span>
          <span class="white--text i-badge">
            {{data.table.items.minimum.price}}
          </span>
        </i-list-item>
        <i-list-item>
          <span>
            <v-icon color="success" class="mr-3">icon-arrow-chart</v-icon>
            Seller with highest price
             ({{data.table.items.maximum.seller}})
          </span>
          <span class="white--text i-badge">
            {{data.table.items.maximum.price}}
          </span>
        </i-list-item>
        <i-list-item>
          <span>
            <v-icon color="primary" class="mr-3">icon-chart-1</v-icon>
            Seller with highest coverage
             ({{data.table.items.coverage.seller}})
          </span>
          <span class="white--text i-badge">
            {{data.table.items.coverage.volume}}
          </span>
        </i-list-item>
        <i-list-item>
          <span>
            <v-icon color="warning" class="mr-3">icon-chart-3</v-icon>
            Seller with larger price range
             ({{data.table.items.range.seller}})
          </span>
          <span class="white--text i-badge">
            {{data.table.items.range.range}}
          </span>
        </i-list-item>
        <i-list-item>
          <span>Seller best in range and coverage</span>
          <span class="white--text i-badge">
            {{data.table.items.rangeCoverage.seller}}
          </span>
        </i-list-item>
      </i-list>
      <i-no-data heading="Oops!" v-if="data.status.noData" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'sellersData',
  props: {
    data: {
      type: [Object, Array],
      default: null
    },
    filters: {
      type: [String, Array, Object],
      default: null
    }
  },
  data: () => ({
    rowsPerPageItems: [10, 25, 50, 100],
    pagination: {
      rowsPerPage: 10
    }
  }),
  mounted () {
    this.requestTable()
    // console.log('XXXXXXXXXXXXXX')
    // let keys = Object.keys(this.data.table.items)
    // console.log(keys)
    // keys.forEach(item => {
    //   console.log(this.data.table.items[item])
    // })
  },
  methods: {
    requestTable () {
      this.$store.dispatch('analyticsSellersRankingModule/getTable', {
        sellers: [],
        categories: [],
        brands: []
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/analytics/sellersRanking.vue